import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AcessibilityGlyph } from '~/components/Acessibility/Acessibility.styled';
import Icons from '~/components/Icons/Icons.component';
import { ensureBackgroundForForeground } from '~/modules/Helper/contrast.helper';
import { useSmarPanelFlag } from '../hooks/useSmarPanelFlag';
import { useSmarPanelAccessMonitorUrl } from '../hooks/useSmarPanelAccessMonitorUrl';
import { useSmarPanelBackOfficeUrl } from '../hooks/useSmarPanelBackOfficeUrl';
import * as S from './smarPanelHeaderButton.styled';

const MENU_TEXT_COLOR = '#ffffff';

function isBackOfficeShortcut(event) {
  if (event.repeat || !event.ctrlKey || !event.altKey || event.metaKey) {
    return false;
  }

  return event.code === 'KeyB' || event.key === 'b' || event.key === 'B';
}

function SmarPanelHeaderButton() {
  const enabled = useSmarPanelFlag();
  const [open, setOpen] = useState(false);
  const backOfficeUrl = useSmarPanelBackOfficeUrl();
  const accessMonitorUrl = useSmarPanelAccessMonitorUrl();
  const corTema = useSelector(state => state.configuration.corTema);
  const botaoBg = ensureBackgroundForForeground(
    corTema,
    MENU_TEXT_COLOR,
    4.5,
    '#1a1a1a'
  );

  useEffect(() => {
    if (!enabled || !backOfficeUrl) return undefined;

    function handleKeyDown(event) {
      if (!isBackOfficeShortcut(event)) return;

      event.preventDefault();
      window.open(backOfficeUrl, '_blank', 'noopener,noreferrer');
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, backOfficeUrl]);

  if (!enabled) {
    return null;
  }

  function handleBlur(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setOpen(false);
    }
  }

  return (
    <S.Wrap
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={handleBlur}
    >
      <S.Trigger
        type="button"
        $bg={botaoBg}
        tabIndex={0}
        aria-label="SmarPanel"
        aria-haspopup="true"
        aria-expanded={open}
        aria-controls="smarpanel-header-menu"
      >
        <AcessibilityGlyph>
          <Icons.ControlOutlined aria-hidden="true" />
        </AcessibilityGlyph>
      </S.Trigger>

      <S.Panel
        id="smarpanel-header-menu"
        role="menu"
        aria-label="SmarPanel"
        $open={open}
      >
        <S.PanelInner $bg={botaoBg}>
          <S.PanelLink to="/smar" role="menuitem" aria-label="Abrir configuração do SmarPanel">
            <S.ItemLabel>PAINEL</S.ItemLabel>
          </S.PanelLink>

          <S.PanelAnchor
            href={backOfficeUrl}
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            aria-label="Abrir página correspondente no BackOffice (Ctrl+Alt+B)"
          >
            <S.ItemLabel>BACKOFFICE</S.ItemLabel>
          </S.PanelAnchor>

          <S.PanelAnchor
            href={accessMonitorUrl}
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            aria-label="WCAG Monitor — avaliar acessibilidade desta página"
          >
            <S.ItemLabel>WCAG MONITOR</S.ItemLabel>
          </S.PanelAnchor>
        </S.PanelInner>
      </S.Panel>
    </S.Wrap>
  );
}

export default SmarPanelHeaderButton;
